import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    // Use matchMedia.matches instead of reading innerWidth to avoid forced reflow
    const handleResize = () => {
      // Use requestAnimationFrame to batch layout reads and avoid forced reflow
      requestAnimationFrame(() => {
        setIsMobile(mql.matches)
      })
    }
    
    // Set initial value using matchMedia.matches (no forced reflow)
    setIsMobile(mql.matches)
    
    // Listen for changes
    mql.addEventListener("change", handleResize)
    
    return () => mql.removeEventListener("change", handleResize)
  }, [])

  return !!isMobile
}
